<script>
  import Button from '@components/buttons/button.svelte'
  import Text from '@components/general/text.svelte'
  import Tag from '@components/general/tag.svelte'
  import FileIcon from '@components/general/file-icon.svelte'
  import { Link } from 'lucide-svelte'
  import { colors } from '@lib/utils/colors'
  import { cn } from '@lib/utils'
  import ago from 's-ago'

  let { resource, label = "Resource" } = $props()

  let color = $derived(resource?.color || 'gray')
  let isLink = $derived(resource?.resource_type === 'link')
</script>

{#if resource}
<Button
  variant="naked"
  path={`/resources/${resource.id}`}
  class={cn('flex flex-col h-full min-h-0', 'group items-start w-full ring-2 ring-offset-4', colors[color]?.ring, colors[color]?.hover_ring)}
>
  <div class="relative block w-full overflow-hidden rounded-lg border border-solid border-gray-200/70 bg-gray-100 aspect-video">
    <div class={cn('inset-0 z-0 h-full w-full relative flex items-center justify-center', colors[color]?.gradient)}>
      {#if isLink}
        <Link size={48} class="text-gray-500/70" strokeWidth={1} />
      {:else}
        <FileIcon file={resource.file || { content_type: 'application/pdf' }} size={48} class="text-gray-500/70" strokeWidth={1} />
      {/if}
    </div>
    {#if isLink}
      <Tag tag={{ name: 'Link', color }} size="xs" class="absolute top-4 right-4 rounded-md px-[6px] shadow-sm" variant="faint" />
    {:else if resource.file?.extension}
      <Tag tag={{ name: resource.file.extension, color }} size="xs" class="absolute top-4 right-4 rounded-md px-[6px] shadow-sm" variant="faint" />
    {/if}
    <Text variant="label" as="span" class="absolute top-4 left-4 uppercase tracking-wider text-gray-600">{label}</Text>
  </div>
  <div class="flex flex-1 flex-col gap-1.5 items-start p-1 w-full min-h-0">
    <Text variant="section_title" text={resource.name} />
    {#if isLink}
      <Tag tag={{ name: 'Link', color }} size="xs" class="rounded-md px-[6px]" variant="faint" />
    {:else if resource.file?.extension}
      <Tag tag={{ name: resource.file.extension, color }} size="xs" class="rounded-md px-[6px]" variant="faint" />
    {/if}
    {#if resource.created_at}
      <Text variant="label" text="Added {ago(new Date(resource.created_at))}" />
    {/if}
    {#if resource.contributor}
      <Text variant="label" text="By {resource.contributor.name}" />
    {/if}
  </div>
</Button>
{/if}
